import { exportTransactions } from '@/dataProvider/transactionsDataProvider/exportTransactions';
import { getList } from '@/dataProvider/transactionsDataProvider/getList';
import { signTransactionWithdrawalOrder } from '@/dataProvider/transactionsDataProvider/signTransactionWithdrawalOrder';

export const transactionsDataProvider = {
  getList,
  exportTransactions,
  signTransactionWithdrawalOrder,
};
